<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_130_56)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3.09255 3.9366C3.03175 3.79145 2.99996 3.62935 3 3.46472V2H21V3.46472C21 3.62935 20.9682 3.79143 20.9074 3.93657C20.8466 4.08172 20.7587 4.20544 20.6515 4.29675L19.0465 5.66406C18.7894 5.88312 18.4873 6.00001 18.1783 6H5.82167C5.51266 6.00001 5.21056 5.88312 4.95346 5.66406L3.3485 4.29672C3.24127 4.20545 3.15335 4.08175 3.09255 3.9366ZM20.9074 21.0634C20.9682 21.2086 21 21.3706 21 21.5353V23L3 23V21.5353C3 21.3707 3.03181 21.2086 3.0926 21.0634C3.1534 20.9183 3.2413 20.7946 3.3485 20.7033L4.95346 19.3359C5.21056 19.1169 5.51266 19 5.82167 19L18.1783 19C18.4873 19 18.7894 19.1169 19.0465 19.3359L20.6515 20.7033C20.7587 20.7945 20.8466 20.9183 20.9074 21.0634ZM18 10.0001H6V12.0001H18V10.0001ZM6 7H18V9H6V7ZM18 13.0001H6V15.0001H18V13.0001ZM17.1035 17.9991H6V15.9991H17.1035C18.1366 15.9979 19.127 15.587 19.8574 14.8566C20.5879 14.1261 20.9988 13.1357 21 12.1027V9.99915H23V12.1027C22.9982 13.6659 22.3764 15.1647 21.271 16.2701C20.1656 17.3755 18.6668 17.9973 17.1035 17.9991Z"
      />
    </g>
    <defs>
      <clipPath id="clip0_130_56">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
